<template>
  <div class="page-content-wrapper user-list-page" v-check-permission="'list-delivery-of-ambos'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <h4 class="mt-0 header-title">Entrega de ambos</h4>
              <p class="text-muted m-b-30 font-14">Desde aquí podras administrar la entrega de ambos.</p>

              <div class="table-rep-plugin">
                <div class="btn-toolbar">
                  <div class="btn-group dropdown-btn-group pull-right">

                  </div>
                  <div class="clearfix"></div>
                </div>

                <div>
                  <div class="row">
                    <div class="col-md-2 mb-3">
                      <input type="number" @keyup.enter="search()" class="form-control" v-model="params.dni" placeholder="DNI" aria-controls="datatable">
                    </div>
                    <div class="col-md-2 mb-3">
                      <select class="custom-select form-control" v-model="params.career">
                        <option :value="null">Carrera</option>
                        <option v-for="career in careers" v-bind:value="career._id">
                          {{ career.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2 mb-3">
                      <select class="custom-select form-control" v-model="params.size">
                        <option :value="null">Talle</option>
                        <option v-for="size in sizes" :value="size.value">{{ size.text }}</option>
                      </select>
                    </div>
                    <div class="col-md-2 mb-3">
                      <button class="btn btn-primary bootstrap-touchspin-up" @click="search()" type="button"><i class="fa fa-search"></i></button>
                      <button class="btn btn-primary" @click="clearFilters()">Limpiar</button>
                    </div>
                    <div class="col-md-4 mb-3">
                      <button class="btn btn-primary pull-right" @click="getAll()"><i class="fa fa-refresh" aria-hidden="true"></i> Mostrar todos</button>
                      <router-link v-check-permission="'edit-delivery-of-ambos'" to="/edit-delivery-of-ambos" class="btn btn-info waves-effect waves-light pull-right mr-3">Nueva entrega</router-link>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row pull-right mb-2">
                <div class="col-md-12">
                  <small><b>({{ items.total }} registros)</b></small>
                </div>
              </div>

              <div class="table-responsive b-0" data-pattern="priority-columns">
                <table class="table table-striped">
                  <thead>
                  <tr>
                    <th>DNI</th>
                    <th>Apellido y nombre</th>
                    <th>Descripción</th>
                    <th>Cantidad</th>
                    <th>Comentarios</th>
                    <th>Estado</th>
                    <th>Entregado el</th>
                    <th class="col-icon" v-check-permission="'edit-delivery-of-ambos'"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="items.docs" v-for="item in items.docs" :key="item._id">
                    <td><b v-if="item.file">{{ item.file.personalData.dni }}</b><span class="badge badge-default" v-else>Sin datos</span></td>
                    <td><b v-if="item.file">{{ item.file.personalData.lastName }} {{ item.file.personalData.firstName }}</b><span class="badge badge-default" v-else>Sin datos</span></b></td>
                    <td>{{ item.deliveredProduct.name }} - {{ item.deliveredProduct.career.name }} - Talle {{ item.deliveredProduct.size }}</td>
                    <td>{{ item.deliveredQuantity }}</td>
                    <td><small>{{ item.comments }}</small></td>
                    <td>
                      <span class="badge badge-info" v-if="item.status == 'reserved'">Reservado</span>
                      <span class="badge badge-success" v-if="item.status == 'delivered'">Entregado</span>
                    </td>
                    <td>{{ item.createdAt | moment("DD/MM/YYYY") }}</td>
                    <td v-check-permission="'edit-delivery-of-ambos'">
                      <!--router-link :to="{ name: 'edit-delivery-of-ambos', params: { id: item._id }}" class="text-info mr-3"><i class="fa fa-pencil"></i></router-link-->
                      <a href="javascript:void(0);" v-check-permission="'edit-delivery-of-ambos'" class="text-primary"  @click="deleteItem(item._id)"><i class="fa fa-minus-circle"></i></a>
                    </td>
                  </tr>
                  <tr v-if="items.docs && items.docs.length === 0">
                    <td colspan="8">No se encontraron registros.</td>
                  </tr>
                  </tbody>
                </table>

                <pagination v-bind:current-page="params.page" v-bind:total-pages="items.pages">
                </pagination>

              </div>

            </div>
          </div>
        </div> <!-- end col -->
      </div> <!-- end row -->

    </div><!-- container -->

  </div>
</template>


<script>
  import config from '../data/config'
  import pagination from '../components/Pagination.vue'
  import sizes from '../data/sizes'

  export default {
    name: 'delivery-of-ambos-list',

    components: {
      pagination
    },

    created () {
      this.getAllCareers();
      this.getAllItems();

      this.$on('pageChanged:pagination', val => {
        this.params.page = val;
        this.getAllItems();
      })
    },


    data () {
      return {
        params: {
          limit: config.pagination.limit,
          page: 1,
          career: null,
          size: null,
          status: null,
          dni: null
        },
        sizes: sizes
      }
    },


    computed: {

      items: function () {
        return this.$store.getters.getAllItemsOfDeliveryOfAmbos
      },

      item: function () {
        return this.$store.getters.getItemOfDeliveryOfAmbos
      },

      careers: function () {
        return this.$store.getters.getAllCareers
      },

    },


    methods: {


      getAllItems () {
        this.$loader.loading();

        this.$store.dispatch('getAllItemsOfDeliveryOfAmbos', { params : this.params })
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },



      getAll: function () {
        this.clearFilters();
        this.getAllItems();
      },



      search: function () {
        if(this.params.career || this.params.size || this.params.status || this.params.dni) {
          this.params.page = 1;
          this.getAllItems();
        }
      },


      clearFilters() {
        this.params.career = null;
        this.params.size = null;
        this.params.status = null;
        this.params.dni = null;
        this.params.page = 1;
      },


      getAllCareers () {
        this.$loader.loading();
        this.$store.dispatch('getAllCareers')
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
          })
      },



      deleteItem (id) {
        var self = this;

        self.$message.delete().then(function (result) {

          if(result.value) {

            self.$message.confirm({
                title: '¿Al eliminar deseas restablecer la cantidad del stock de la prenda eliminada?',
                text: 'Esta acción no se puede deshacer. Si no seleccionas ninguna opcion se elimina la entrega pero sin restablecer stock.',
                confirmButtonText: 'Eliminar restableciendo stock',
                cancelButtonText: 'Eliminar sin restableder stock'
              }).then(function (result2) {

              if(result2.value) {

                self.$store.dispatch('deleteItemOfDeliveryOfAmbos', { params: {_id: id, recoverStock: true} })
                  .then((response) => {
                    if (response.success) {
                      self.$message.success();
                    } else {
                      self.$message.error({text: response.message});
                    }
                  })
                  .catch((response) => {
                    self.$message.error({text: response.message});
                  })

              } else {

                self.$store.dispatch('deleteItemOfDeliveryOfAmbos', { params: {_id: id, recoverStock: false} })
                  .then((response) => {
                    if (response.success) {
                      self.$message.success();
                    } else {
                      self.$message.error({text: response.message});
                    }
                  })
                  .catch((response) => {
                    self.$message.error({text: response.message});
                  })

              }
            })
          }
        })
      },


    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/screens/DeliveryOfAmbosListScreen.vue